import { render, staticRenderFns } from "./shuibk.vue?vue&type=template&id=deff0994&scoped=true&"
import script from "./shuibk.vue?vue&type=script&lang=js&"
export * from "./shuibk.vue?vue&type=script&lang=js&"
import style0 from "./shuibk.vue?vue&type=style&index=0&id=deff0994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deff0994",
  null
  
)

export default component.exports